/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTcuNDM3NSAyLjYyNUgxMi4yNVYxMS4zNzVINy40Mzc1TDcuNDM3NSAyLjYyNVpNNi41NjI1IDIuNjI1TDYuNTYyNSAxMS4zNzVIMS43NVYyLjYyNUg2LjU2MjVaTTYuNTYyNSAxMi4yNUgwLjg3NVYxLjc1SDYuNTYyNUgxMy4xMjVWMTIuMjVINy40Mzc1SDYuNTYyNVoiIGZpbGw9ImJsYWNrIi8+PC9zdmc+";